import { baseApiUrl, fetcher } from 'data_sources/constants';

export interface ExportIssuedManualParams {
  manualId: string;
  showEditLevelTags: boolean;
  showAccreditationTags: boolean;
}

export interface ExportIssuedManualResponse {
  jobId: string;
  presignedUrl: string;
}

export const getExportIssuedManualData = async (
  params: ExportIssuedManualParams
): Promise<ExportIssuedManualResponse> => {
  const { manualId, showEditLevelTags, showAccreditationTags } = params;
  const url = `${baseApiUrl()}/lexipub/export/v1/manuals/${manualId}/export`;

  const queryParams = new URLSearchParams({
    showEditLevelTags: showEditLevelTags.toString(),
    showAccreditationTags: showAccreditationTags.toString(),
  });

  const finalUrl = `${url}?${queryParams.toString()}`;

  const data = await fetcher({
    method: 'post',
    url: finalUrl,
  });

  return data;
};

export const exportIssuedManual = async (
  params: ExportIssuedManualParams,
  onSuccess?: (response: ExportIssuedManualResponse) => void,
  onError?: (error: any) => void
) => {
  try {
    const response = await getExportIssuedManualData(params);
    if (onSuccess) {
      await onSuccess(response);
    }
    return response;
  } catch (error) {
    if (onError) {
      onError(error);
    }
    throw error;
  }
};
